import { render, staticRenderFns } from "./joinHall.vue?vue&type=template&id=8890c8b2&scoped=true"
import script from "./joinHall.vue?vue&type=script&lang=js"
export * from "./joinHall.vue?vue&type=script&lang=js"
import style0 from "./joinHall.vue?vue&type=style&index=0&id=8890c8b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8890c8b2",
  null
  
)

export default component.exports